// extracted by mini-css-extract-plugin
export default {"demoPage":"Demo_demoPage__41CbF"};